export const trackChangesEditModes = {
  EDITING_MODE: "EDITING_MODE",
  SUGGESTING_MODE: "SUGGESTING_MODE",
} as const;

export function isTrackChangesEditMode(str: string): str is TrackChangesEditMode {
  return !!Object.values(trackChangesEditModes).find((displayMode) => str === displayMode)
}
